export const destroy = (self) => {
  if (self._touchStartHandler != null) {
    self._canvas_el?.removeEventListener(
      "touchstart",
      self._touchStartHandler,
      {
        passive: false,
      }
    );
    self._touchStartHandler = null;
  }
  if (self._touchMoveHandler != null) {
    self._window.removeEventListener("touchmove", self._touchMoveHandler, {
      passive: false,
    });
    self._touchMoveHandler = null;
  }
  if (self._touchEndOrCancelHandler != null) {
    self._window.removeEventListener(
      "touchend",
      self._touchEndOrCancelHandler,
      {
        passive: false,
      }
    );
    self._window.removeEventListener(
      "touchcancel",
      self._touchEndOrCancelHandler,
      {
        passive: false,
      }
    );
    self._touchEndOrCancelHandler = null;
  }
  if (self._canvas_el != null) {
    self._container_el?.removeChild(self._canvas_el);
  }
  if (self._target_image_dummy_g_el != null) {
    self._target_image_el?.removeChild(self._target_image_dummy_g_el);
  }
  if (self._target_image_el != null) {
    self._target_image_layer_el?.removeChild(self._target_image_el);
  }
  self._container_el = null;
  self._canvas_el = null;
  self._dummy_g_el = null;
  self._layers_el = null;
  self._target_image_layer_el = null;
  self._cutting_line_layer_el = null;
  self._path_editor_layer_el = null;
  self._target_image_dummy_g_el = null;
  self._cutting_line_clip_path_el = null;
  self._cutting_line_display_path_el = null;
  self._path_editor_line_container_el = null;
  self._path_editor_point_container_el = null;
  self._view_port = null;
  self._view_box = null;
  self._stroke_sync = null;
  self._target_image_el = null;
  self._path_editor_list = [];
  self._path_editor_point_size_controller = null;
  self._processing_task = null;
  self._touchStartHandler = null;
  self._touchMoveHandler = null;
  self._touchEndOrCancelHandler = null;
  self._touch_map = new Map();
  self._zooming_and_panning_touch_id1 = null;
  self._zooming_and_panning_progress_touch_x1 = 0;
  self._zooming_and_panning_progress_touch_y1 = 0;
  self._zooming_and_panning_touch_id2 = null;
  self._zooming_and_panning_progress_touch_x2 = 0;
  self._zooming_and_panning_progress_touch_y2 = 0;
  self._path_editing_touch_id = null;
  self._path_editing_progress_touch_x = 0;
  self._path_editing_progress_touch_y = 0;
};
